@if(loadingSgnl()) {
  <app-loading-overlay class="block fixed top-0 bottom-0 right-0 left-0 z-99999"></app-loading-overlay>
}

<router-outlet></router-outlet>
